class CarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }
  }

  init() {
    // 確保 Swiper 已載入(比照 advanced-slider.js)
    if (typeof Swiper === 'undefined') {
      const script = document.createElement('script');
      script.src = '{{ "swiper.min.js" | asset_url }}';
      script.onload = () => this.initSwiper();
      document.head.appendChild(script);
    } else {
      this.initSwiper();
    }
  }

  initSwiper() {
    const el = this.querySelector('.carousel-main');
    if (!el) return;

    // 避免在 theme editor 重新載入時重複初始化
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const dotsWrap = this.querySelector('.carousel-dots');
    const slides = el.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;

    const enableAutoplay = el.dataset.enableAutoplay === 'true';
    const autoplaySpeed = (parseFloat(el.dataset.autoplaySpeed) || 5) * 1000;
    const sliderLoop = el.dataset.sliderLoop === 'true';

    // 1) 依 slide 數動態產生固定點點(插在 pill 之後)
    this.dots = [];
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.carousel-dots__dot').forEach((d) => d.remove());
      for (let i = 0; i < slideCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'carousel-dots__dot';
        dot.setAttribute('aria-label', `前往第 ${i + 1} 張`);
        dot.addEventListener('click', () => {
          if (!this.swiper) return;
          sliderLoop ? this.swiper.slideToLoop(i) : this.swiper.slideTo(i);
        });
        dotsWrap.appendChild(dot);
        this.dots.push(dot);
      }
    }

    // 單張 slide 不需指示器與互動
    if (slideCount <= 1) {
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    const movePill = () => this.movePill();

    // 2) 初始化 Swiper
    this.swiper = new Swiper(el, {
      loop: sliderLoop,
      speed: 600,
      grabCursor: true,
      watchSlidesProgress: true,
      autoplay: enableAutoplay
        ? { delay: autoplaySpeed, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      a11y: { enabled: true },
      on: {
        init: movePill,
        slideChange: movePill,
        resize: movePill,
      },
    });

    // 3) resize 時重新量測藥丸位置(點點間距可能改變)
    this._onResize = () => this.movePill();
    window.addEventListener('resize', this._onResize);
  }

  // 將高亮藥丸平滑移動到目前真實 slide 對應的點點位置
  movePill() {
    if (!this.swiper || !this.dots || !this.dots.length) return;
    const pill = this.querySelector('.carousel-dots__pill');
    if (!pill) return;

    const index = this.swiper.realIndex || 0;
    const activeDot = this.dots[index];
    if (!activeDot) return;

    // pill 與第一顆點點同一個 left 起點;位移 = 該點點相對第一顆點點的 offset
    const firstDot = this.dots[0];
    const offset = activeDot.offsetLeft - firstDot.offsetLeft;
    // 讓藥丸置中對齊點點(藥丸比點點寬)
    const pillWidth = pill.offsetWidth;
    const dotWidth = activeDot.offsetWidth;
    const centerShift = (pillWidth - dotWidth) / 2;

    pill.style.transform = `translateX(${offset - centerShift}px)`;

    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }
}

customElements.define('carousel-slider', CarouselSlider);

// Theme editor:section 重新載入時重新初始化
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('carousel-slider').forEach((c) => {
    if (typeof c.init === 'function') c.init();
  });
});
